import { Button, Icon, Loading } from '@startlibs/components';
import { smoothScroll } from '@startlibs/utils';
import {useToggle} from '@startlibs/core';
import React, {useEffect, useRef, useState} from 'react';
import _ from 'lodash/fp'
import {AddButton} from '../components/AddButton';
import {
  AssignmentStatusBox,
} from '../admin/steps/expertReview/ExpertReviewList';
import {
  CASE_ARCHIVED,
  CASE_CLOSED,
  CASE_REJECTED,
  CASE_REVIEWED,
  REQUEST_REJECTED,
  WAITING_ACCEPTANCE,
  WAITING_MEDICAL_RECORDS
} from '../enums/CaseState';
import {
  Card,
  PageContainer,
  PageFooter,
  SectionHeading
} from '../components/PageLayout';
import {ConfirmDialog, useConfirmDialog, useConfirmDialogWithProps} from '../hooks/useConfirmDialog'
import {Header} from '../components/Header'
import {MEDICAL_RELEASE_PATH} from '../request/medicalRelease/ReleaseLocationForms'
import {MedicalReleaseForm} from '../request/MedicalReleaseForm'
import {PageLoadingSuspense} from '../components/PageLoading'
import {PurviewFooter} from '../components/PurviewFooter'
import {ReleaseList} from './ReleaseList'
import {ReleaseLocationCard} from '../request/medicalRelease/ReleaseLocationCard'
import {getJwt} from '../hooks/useJwt';
import {isStateBefore} from '../request/utils';
import {jwtFormFetcher, jwtGetFetcher, jwtPostFetcher} from '../utils/authFetch'
import {locationIsNotEmpty} from '../request/forms/MedicalRecordLocationForm'
import { setNotification } from '../components/Notifications';
import {useSetConfirmExitPage} from '../hooks/useConfirmExitPage';
import {willUseSuspense} from '../hooks/useSuspense'
import { HOSPITALS, SCAN_FACILITIES, BIOPSY_FACILITIES, PHYSICIAN_OR_PROVIDER, OTHER_FACILITIES } from '../enums/MedicalRecordLocationType';
import { INSTITUTION, REVIEW, UPLOAD } from '../enums/UploaderManagement';
import { EmptyMedicalRecordsList } from '../request/RequestOverview';
import {FormattedMessage, useIntl} from "react-intl";

const EditItemButton = ({release, setRelease}) => {
  const intl = useIntl()
  const suspend = useConfirmDialog(<ConfirmDialog
      title={intl.formatMessage({
        defaultMessage: "Suspend authorization",
        description: "Medical records release, suspend authorization dialog title"
      })}
    closeLabel={intl.formatMessage({
      defaultMessage:"Cancel",
      description:"Cancel button"
    })}
      action={() => jwtPostFetcher(getJwt())("/api/medicalRecordLocationForm", {locationFormId: release.id}, {method: "DELETE"})}
      confirm={<Button alert><FormattedMessage
        defaultMessage="Suspend authorization"
        description="Medical records release, suspend authorization button"
      /></Button>}
      onSuccess={() => setRelease(_.set('suspend', true))}
      notify={intl.formatMessage({
          defaultMessage: "Authorization suspended successfully.",
        description: "Medical records release, authorization suspended notification"
      })}
    >
      <FormattedMessage
        defaultMessage={`<p>You are about to suspend a medical records release authorization, meaning no new medical records requests to the following healthcare provider will be authorized:</p>
        {ReleaseLocationCard}      
      <p>Are you sure you want to suspend this authorization?</p>
      <p>Medical records provided prior to this date, as authorized by this institution, will still be valid and will not be revoked.</p>`}
        description="Medical records release, suspend authorization dialog content"
        values={{
          p: msg => <p>{msg}</p>,
          ReleaseLocationCard: <ReleaseLocationCard location={release.medicalRecordLocationItem}/>
        }}
      />

    </ConfirmDialog>
  )

  return <Button small alpha onClick={suspend}><FormattedMessage
    defaultMessage="Suspend authorization"
    description="Medical records release, suspend authorization button"
  /></Button>
}

const DeleteItemButton = ({release, setReleases}) => {
  const intl = useIntl()
  const suspend = useConfirmDialog(<ConfirmDialog
      title={intl.formatMessage({
        defaultMessage: "Remove provider",
        description: "Medical records release, remove provider dialog title"
      })}
      action={() => jwtPostFetcher(getJwt())("/api/medicalRecordLocationForm", {locationFormId: release.id}, {method: "DELETE"})}
    closeLabel={intl.formatMessage({
      defaultMessage:"Cancel",
      description:"Cancel button"
    })}
      confirm={<Button alert><FormattedMessage
        defaultMessage="Remove"
        description="Medical records release, remove provider button"
      /></Button>}
      onSuccess={() => setReleases(_.reject(_.matchesProperty('id', release.id)))}
      notify={intl.formatMessage({
          defaultMessage: "Provider successfully removed.",
        description: "Medical records release, provider removed notification"
      })}
    >
      <FormattedMessage
        defaultMessage={`<p>
        This will suspend their medical records release, and they will no
        longer be authorized to provide records.
      </p>
      {ReleaseLocationCard}
      <p>Are you sure you want to proceed?</p>
      <p>
        Medical records provided prior to this date, as authorized by
        this institution, will still be accessible.
      </p>`}
        description="Medical records release, remove provider dialog content"
        values={{
          p: msg => <p>{msg}</p>,
          ReleaseLocationCard: <ReleaseLocationCard location={release.medicalRecordLocationItem}/>
        }}
      />
    </ConfirmDialog>
  )

  return <Button small alpha onClick={suspend}><FormattedMessage
    defaultMessage="Remove"
    description="Medical records release, remove provider button"
  /></Button>
}

const getValues = (releases) => ({
  [MEDICAL_RELEASE_PATH]: _.reject(_.get('medicalRecordsReleaseLicense.signature'), releases)
    .map(({medicalRecordLocationItem, id}, i) => ({
        ...medicalRecordLocationItem,
        serverId: id,
        id: Date.now() + "-" + i
      })
    )
})
const useAuthSuspense = willUseSuspense((requestId) =>
  jwtGetFetcher(getJwt())(`/api/medicalRecordLocationForms`, {requestId})
)

export const PatientMedicalReleaseStep = (props) => <>
  <LoadedPatientMedicalReleaseStep {...props}/>
</>


export const LoadedPatientMedicalReleaseStep = ({caseRequest, setCaseRequest, step, setStep, mode, setProgress}) => {
  const intl = useIntl()
  const sessionIndexes = []
  // const [releases, setReleases] = useState(useAuthSuspense(caseRequest.requestId).filter((item, index) => sessionIndexes.includes(index)))
  const [releases, setReleases] = useState(useAuthSuspense(caseRequest.requestId).filter((item, index) => sessionIndexes.includes(index) || item.medicalRecordsReleaseLicense.date === null))
  const [sessionReleases, setSessionReleases] = useState([])
  const [isRefreshing,setIsRefreshing] = useState(false)
  
  const refreshReleases = (values) =>
    jwtGetFetcher(getJwt())(`/api/medicalRecordLocationForms`, {requestId: caseRequest.requestId})
      .then((response) => {
        setSessionReleases(sessionReleases.concat(values))
        let concated = _.concat(sessionReleases,values)
        // It is necessary to map releases added in this session and compare then with releases that came from database
        // As the unique id is generated on backend and not returned, it will check every field.
        response.map((item, index) => {
          concated.map((sItem, sIndex) => {
            sItem?.records?.map((record) =>{
              if(item.medicalRecordLocationItem.name == record.item.name 
                && item.medicalRecordLocationItem.city == record.item.city 
                && item.medicalRecordLocationItem.contactName == record.item.contactName 
                && item.medicalRecordLocationItem.dateExpiration == record.item.dateExpiration 
                && item.medicalRecordLocationItem.dateFrom == record.item.dateFrom 
                && item.medicalRecordLocationItem.dateTo == record.item.dateTo 
                && item.medicalRecordLocationItem.email == record.item.email 
                && item.medicalRecordLocationItem.locationType == record.item.locationType 
                && item.medicalRecordLocationItem.phoneNumber == record.item.phoneNumber){
                  sessionIndexes.push(index)
              }
            }) 
          })
        })
        setReleases(response.filter((item, index) => sessionIndexes.includes(index)))
        setIsRefreshing(false)
      })
      
  const formRef = useRef()
  const submitRef = useRef()

  const releasesActive = isStateBefore(caseRequest.state, WAITING_ACCEPTANCE) || caseRequest.state === CASE_REVIEWED

  const SHOW_ALL_EMPTY = {
    [MEDICAL_RELEASE_PATH]: [HOSPITALS, SCAN_FACILITIES, BIOPSY_FACILITIES, PHYSICIAN_OR_PROVIDER].map((locationType, i) => ({
      id: Date.now() + '-' + i,
      locationType
    }))
  }

  const addAuthorizations = useToggle(!releases.length && releasesActive)
  
  !addAuthorizations.isOpen && step === INSTITUTION && (releasesActive || releases.length > 0) && addAuthorizations.openWith(getValues(releases))
  addAuthorizations.isOpen && step === REVIEW && releases.length == 0 && addAuthorizations.close()
  const action = (values) => jwtFormFetcher(getJwt())('/api/medicalRecordLocationForm', {method: 'PUT'})(values)
    .then(() => setCaseRequest(_.unset('needReleases')))
    .then(() => {
      setIsRefreshing(true)
      setSessionReleases(_.concat(sessionReleases,values));
      refreshReleases(values);
    })
    .then(addAuthorizations.close)
    // const action = (values) => console.log(values)
    

  const saveLoading = useToggle()
  const saveAction = () => formRef.current
    ? saveLoading.wait(jwtPostFetcher(getJwt())('/api/medicalRecordLocationForm', formRef.current.getTransformedValues(), {method: 'PUT'}))
    : Promise.resolve()

  const onSuccess = (values) => {
    setNotification(intl.formatMessage({
      defaultMessage:"Changes saved successfully.",
      description: "Saved changes notification"
    }))
    addAuthorizations.close()
    setStep(REVIEW)
    setProgress(3) // Filled medical releases in this session
    addAuthorizations.close()
    setCaseRequest(_.flow(
      _.unset('needReleases'),
      _.set('caseFlags.patientDoneFlags.doneMedicalReleases', true),
    ))
  }
  const confirmExitDialog = useConfirmDialogWithProps(({exit, save, isSubmittingCase}) => <ConfirmDialog
      title={isSubmittingCase ? intl.formatMessage({
        defaultMessage: 'Would you like to save changes before submitting?',
        description: 'Medical records release, discard changes dialog, save changes before submitting dialog title'
      }) : intl.formatMessage({
        defaultMessage:'Cancel adding records locations?',
        description: 'Medical records release, discard changes dialog, cancel adding records locations dialog title'
      })}
      closeButton={false}
      alternativeButton={<Button hover="alert" onClick={exit}><FormattedMessage
        defaultMessage="Discard changes to locations"
        description="Medical records release, discard changes dialog, discard button"
      /></Button>}
      confirm={<Button
        success onClick={() => {
        confirmExitDialog.close();
        smoothScroll(submitRef.current);
        save().then(exit)
      }}
      ><FormattedMessage
        defaultMessage="Save locations"
        description="Medical records release, discard changes dialog, save button"
      /></Button>}
    >
      <p>
        {isSubmittingCase
          ? intl.formatMessage({
            defaultMessage: 'There are unsaved changes in this page. Would you like to save them before submitting?',
            description: 'Medical records release, discard changes dialog, changes before submitting content'
          })
          : intl.formatMessage({
            defaultMessage: 'You are about to leave this page without saving the changes to the medical records locations.',
            description: 'Medical records release, discard changes dialog, leaving page content'
          })
        }
      </p>
      {!isSubmittingCase && <p><FormattedMessage
        defaultMessage="Are you sure you want to cancel adding these locations?"
        description="Medical records release, discard changes dialog, cancel adding locations confirmation"
      /></p>}
    </ConfirmDialog>
  )

  const confirmExitPage = (isSubmittingCase) => () => {
    if (!formRef.current) {
      return
    }
    const records = formRef.current.getValue(MEDICAL_RELEASE_PATH)
    if (!!records.find(locationIsNotEmpty)) {
      return new Promise((exit) => {
        confirmExitDialog.openWith({exit, save: formRef.current.submitForm, isSubmittingCase})
      })
    }
  }
  useSetConfirmExitPage(confirmExitPage(false))
  return <>
    
      {step !== INSTITUTION && mode !== UPLOAD &&
        <Header title={intl.formatMessage({
          defaultMessage: "Healthcare facilities",
          description: "Medical records release, header title"
        })}></Header>
      }
      
      {
        !releasesActive && <AssignmentStatusBox>
          <div className="waitingBoxContent">
            <Icon icon="clock"/>
            <h4><FormattedMessage
              defaultMessage="This case can no longer receive new medical records or releases"
              description="Medical records release, case closed message"
              />
            </h4>
            <p>
              {caseRequest.state === (CASE_REVIEWED || CASE_CLOSED) ?
                <FormattedMessage
                  defaultMessage="This case was already reviewed."
                  description="Medical records release, case reviewed message"
                />
                : caseRequest.state === (CASE_REJECTED || REQUEST_REJECTED || CASE_ARCHIVED) ?
                "" : <FormattedMessage
                    defaultMessage="There is an expert reviewing the case."
                    description="Medical records release, case waiting for review message"
                  />
              } <FormattedMessage
              defaultMessage="Requesting facilities for records and editing releases are locked."
              description="Medical records release, case locked message"
            /></p>
          </div>
        </AssignmentStatusBox>
      }
      {
        ((!addAuthorizations.isOpen && (releasesActive || releases.length > 0)) && (step === REVIEW)) && <>
          <Card css={mode === UPLOAD ? "padding: 0; border: 0px;" : "" }>
            {isRefreshing && <div css="margin-left: 50%; transform: translate(-13px, 0px); margin-bottom: 1.5rem;"><Loading /></div>}
            {(releases.length == 0 && !isRefreshing )&& <EmptyMedicalRecordsList><FormattedMessage
              defaultMessage="No facilities were added."
              description="Medical records release, no facilities added message"
            /></EmptyMedicalRecordsList>}
            <ReleaseList
              isPatient
              setReleases={setReleases}
              releases={releases}
              caseRequest={caseRequest}
              suspendedButton={(releases) => <Button
                small alpha
                onClick={() => {addAuthorizations.openWith(getValues(releases));  setStep(INSTITUTION)}}
              ><FormattedMessage
                defaultMessage="Sign"
                description="Medical records release, sign button"
              /></Button>}
              editItemButton={(release, setRelease) =>
                release.medicalRecordsReleaseLicense?.signature
                  ? <EditItemButton release={release} setRelease={setRelease}/>
                  : <DeleteItemButton release={release} setReleases={(update) => setReleases(update)}/>
              }
            >{releases =>
              releasesActive && mode === UPLOAD &&
              <AddButton onClick={() => {addAuthorizations.openWith(getValues(releases)); setStep(INSTITUTION)}}><FormattedMessage
                defaultMessage="Add facility"
                description="Medical records release, add facility button"
              /></AddButton>
            }</ReleaseList>
          </Card>
         
        </>
      }
      {
        addAuthorizations.isOpen && step !== REVIEW &&
        <MedicalReleaseForm
          setCaseRequest={setCaseRequest}
          withReleaseSignoff
          alwaysSave
          values={addAuthorizations.isOpen}
          optional
          formRef={formRef}
          caseRequest={caseRequest}
          onSuccess={onSuccess}
          action={action}
          step={step}
          mode={mode}
          toggle={() => {addAuthorizations.close(); setStep(REVIEW)}}
        >{(form, clearButton, isEmpty) =>
          <PageFooter>
            {
              isEmpty
                ? <>
                  <Button onClick={() => {addAuthorizations.close(); setStep(REVIEW)}}><FormattedMessage
                    defaultMessage="Skip"
                    description="Skip button"
                  /></Button>
                </>
                : <>
                  <Button onClick={() => {addAuthorizations.close(); setStep(REVIEW)}}><FormattedMessage
                    defaultMessage="Cancel"
                    description="Cancel button"
                  /></Button>
                  {clearButton}
                  <Button
                    ref={submitRef}
                    highlight
                    type="submit"
                    isLoading={form.isLoading}
                  ><FormattedMessage
                    defaultMessage="Save"
                    description="Save button"
                  /></Button>
                </>
            }

          </PageFooter>
        }
        </MedicalReleaseForm>
      }
  </>
}
